import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[500px] md:h-[620px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Epic%20cinematic%20movie%20theater%20interior%20with%20warm%20golden%20lighting%2C%20luxurious%20red%20velvet%20seats%2C%20grand%20stage%20with%20glowing%20screen%2C%20Hollywood%20premiere%20atmosphere%2C%20elegant%20architecture%2C%20soft%20dramatic%20spotlights%2C%20rich%20amber%20and%20deep%20crimson%20tones%2C%20cinematic%20composition&width=1600&height=900&seq=hero-main&orientation=landscape"
        alt="欧美一区二区 - 高清影视内容分区导航平台"
        title="欧美一区二区·高清内容聚合平台"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/60"></div>
      <div className="absolute inset-0 flex items-center">
        <div className="container-main w-full">
          <div className="max-w-2xl">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary-500/90 backdrop-blur-sm text-background-50 text-xs md:text-sm font-medium mb-5">
              <i className="ri-sparkling-line"></i>
              <span>2026暑期档热门大片火热更新中</span>
            </div>
            <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 mb-4 leading-tight">
              欧美一区二区
              <span className="block text-xl md:text-2xl lg:text-3xl font-medium mt-2 text-background-200">
                高清内容聚合平台
              </span>
            </h1>
            <p className="text-sm md:text-base text-background-300 mb-8 max-w-lg leading-relaxed">
              专业欧美影视内容分区导航，精准划分欧美一区二区资源，覆盖多类型、多语言欧美影视内容。更新及时，分区清晰，一站式满足您的欧美影视需求。
            </p>
            <div className="flex flex-col sm:flex-row gap-3">
              <Link
                to="/category/zone-one"
                className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-lg bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                探索欧美一区
                <i className="ri-arrow-right-line"></i>
              </Link>
              <Link
                to="/category/zone-two"
                className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-lg bg-background-50/15 backdrop-blur-sm text-background-50 font-medium text-sm hover:bg-background-50/25 transition-colors border border-background-50/20 whitespace-nowrap cursor-pointer"
              >
                浏览欧美二区
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}